import { AreaDesignation } from "@miplatform/types";
import { formatDate } from "@miplatform/utils";
import { useSeries } from "@mibuildweb/hooks";
import { useCreateBidContext } from "../CreateBidContext";

export const useBidPrintHeaderViewModel = () => {
  const { form, accounts, communities, seriesGroups, floors } =
    useCreateBidContext();
  const { watch } = form;
  const {
    name,
    additionalFeatures,
    pipeBrand,
    builderId,
    communityId,
    seriesId,
    seriesGroupId,
    planAreas,
    bidRequest,
  } = watch();

  const { series, getSeries } = useSeries();

  const builderName = accounts.find((a) => a.id === builderId)?.name ?? "";
  const community = communities.find((c) => c.id === communityId);
  const communityName = community?.name ?? "";
  const cityName = community?.city?.cityName ?? "";
  const regionCode = community?.regionCode ?? "";
  const seriesGroupName =
    seriesGroups.find((sg) => sg.id === seriesGroupId)?.name ?? "";
  const seriesName = series.find((s) => s.id === seriesId)?.name ?? "";
  const collectionSeries = [seriesGroupName, seriesName]
    .filter(Boolean)
    .join(" ");
  const cityRegion = [cityName, regionCode].filter(Boolean).join(", ");
  const subdivision = [communityName, cityRegion].filter(Boolean).join(" - ");

  const bath = planAreas.filter(
    (a) => a.areaDesignation === AreaDesignation.Bath
  );
  const halfBath = planAreas.filter(
    (a) => a.areaDesignation === AreaDesignation.HalfBath
  );
  const hasBaths = bath.length > 0 || halfBath.length > 0;
  const numberOfBaths = [bath.length, ...halfBath.map(() => ".5")].join("");
  const numberOfFloors = [...new Set(planAreas.map((a) => a.floorId))];
  const firstSelectedFloor = floors.find((floor) =>
    numberOfFloors.includes(floor.id)
  );
  const firstFloorId = firstSelectedFloor?.id ?? numberOfFloors[0];
  const upBath = bath.filter((a) => a.floorId !== firstFloorId);
  const upHalfBath = halfBath.filter((a) => a.floorId !== firstFloorId);
  const hasUpBaths = upBath.length > 0 || upHalfBath.length > 0;
  const numberOfUps = [upBath.length, ...upHalfBath.map(() => ".5")].join("");

  const headerDescription = [
    hasBaths && `${numberOfBaths} Bath${numberOfBaths > "1" ? "s" : ""}`,
    numberOfFloors.length > 0 && `${numberOfFloors.length} Story`,
    hasUpBaths && `${numberOfUps} Up`,
    additionalFeatures,
  ]
    .filter(Boolean)
    .join(" - ");

  const requestDate = bidRequest?.requestDate
    ? formatDate(bidRequest.requestDate, "MM/DD/YYYY")
    : "--/--/--";

  return {
    name,
    additionalFeatures,
    pipeBrand,
    builderName,
    collectionSeries,
    subdivision,
    headerDescription,
    requestDate,
    seriesGroupId,
    builderId,
    getSeries,
  };
};
